<template>
<!-- Research Article -->
  <div class="g-bg-gray">
    <div class="container">
      <div class="row justify-content-lg-between align-items-center">
        <div class="col-md-6 g-mt-70 g-mb-0--md">
          <img class="img-fluid u-shadow-v39 g-brd-around g-brd-10 g-brd-white rounded" src="../../../../static/assets/img/FamilyImages/Portal Photo_FamilyImage1.jpeg" alt="Image Description">
        </div>

        <div class="col-md-5">
          <div class="g-mt-20 text-center">
            <h1 class="mb-3">Help Page</h1>
            <p class="g-font-size-20">We’re here to support you, whether that’s through hardware or knowledge.</p>
          </div>
          <!-- <a class="btn u-shadow-v39 g-color-white g-bg-main g-bg-primary--hover g-font-size-default g-rounded-30 g-px-35 g-py-11" href="#">Read More</a> -->
        </div>
      </div>
    </div>
    <help-block></help-block>
  </div>
<!-- End Research Article -->
</template>
<script>
import HelpBlock from "@/components/portal/helpData/HelpBlock";
export default {
  components: {HelpBlock}
}
</script>


// WEBPACK FOOTER //
// HelpArticle.vue?38054693